// extracted by mini-css-extract-plugin
module.exports = {"verify-code":"VerifyCode_verify-code__3Z4QI"};